import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import {
  CreateLiveSession,
  JoinLiveSession,
  LiveSessionList,
  SingleLiveSession,
} from "@/builders/types/live-sessions";

const get = function (
  params?: FilterParams<{
    from_date?: string;
    to_date?: string;
  }>
) {
  return api
    .get<LiveSessionList>("live-sessions", { params })
    .then(({ data }) => data);
};

const id = function (id: number) {
  return api
    .get<SingleLiveSession>(`live-sessions/${id}`)
    .then(({ data }) => data);
};

const create = function (data: Partial<CreateLiveSession>) {
  return api
    .post<SingleLiveSession>(`live-sessions`, data)
    .then(({ data }) => data);
};

const update = function (variables: {
  id: number;
  data: Partial<CreateLiveSession>;
}) {
  const { id, data } = variables;
  return api
    .put<SingleLiveSession>(`live-sessions/${id}`, data)
    .then(({ data }) => data);
};

const join = function (id: number) {
  return api
    .get<JoinLiveSession>(`live-sessions/${id}/join`)
    .then(({ data }) => data);
};

export const live_sessions = {
  join,
  update,
  create,
  get,
  id,
};
